import { render } from "./Sidebar.vue?vue&type=template&id=46302a7e&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=46302a7e&lang=scss&scoped=true"

import exportComponent from "/home/phamdat/project/pos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46302a7e"]])

export default __exports__